import { useSelector } from 'react-redux'
import {
  latestUserEhrAppointmentSelector,
  pendingEhrAppointmentsSelector,
} from '@screens/NutritionistHub/models/nutritionistHub.selectors.ts'
import { getAppointmentDetails } from '@screens/NutritionistHub/utils.ts'
import { Subscription } from '@src/types.ts'

export const usePaidCallCreditCount = (subscription?: Pick<Subscription, 'id'>) => {
  const pendingAppointments = useSelector(pendingEhrAppointmentsSelector)
  const latestAppointment = useSelector(latestUserEhrAppointmentSelector)
  const latestAppointmentDetails = latestAppointment
    ? getAppointmentDetails(latestAppointment)
    : undefined

  if (!subscription) {
    return (
      pendingAppointments.length +
      (latestAppointmentDetails?.isCallConfirmed || latestAppointmentDetails?.isCallInReview
        ? 1
        : 0)
    )
  }

  const pendingAppointmentCount = pendingAppointments.filter((appointment) =>
    appointment.attendances.some(
      (attendance) => attendance.invoice?.subscription?.id === subscription.id,
    ),
  ).length

  const countLatestAppointment =
    latestAppointment?.attendances.some(
      (attendance) => attendance.invoice?.subscription?.id === subscription.id,
    ) &&
    (latestAppointmentDetails?.isCallConfirmed || latestAppointmentDetails?.isCallInReview)

  return pendingAppointmentCount + (countLatestAppointment ? 1 : 0)
}
